module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAMNJREFUaEPtmEsOwCAIROX+h6bbhi7MZDRE+7qt5TMPqhLj8CcOj3+QQDdBCBxHIDPzHXREWBRde7Jz12El5tojAUrI7ClKiBJaXUL1tzbbqFYTUP19eoAEZhKW965g9xEQBWxfLu8D7RGXAEigmwgEIGAqQAmZAtqfQ8CW0DRwHwH3dKgK6vq77zTqKgKBiQL1Cis3sTsKZLTo3gcgMLnUq2MaekBVjCb+fROrO+3u9XIT7w5ItU8CqmKr10NgtaKqvQfTCsAxN233wgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/canselfull1.png
// module id = ol4X
// module chunks = 1